import { render, staticRenderFns } from "./SuperAdminLayout.vue?vue&type=template&id=02f934b1&"
import script from "./SuperAdminLayout.vue?vue&type=script&lang=js&"
export * from "./SuperAdminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports